
























import { Vue, Prop, Component } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '../rules/rules';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class ReadOnlyTextField extends Vue {
  @Prop({
    required: false,
    default: '',
  })
  private label!: string;

  @Prop({
    required: false,
    default: '',
  })
  private value!: string;

  @Prop({
    required: false,
    default: '',
  })
  private placeholder!: string;

  @Prop({
    required: false,
    default: () => [],
  })
  private rules!: Rules;

  @Prop({
    required: false,
    default: 100,
  })
  private maxLength!: number

  @Prop({
    required: false,
    default: false,
  })
  private disabled!: boolean

  private get inputValue() {
    return this.value;
  }

  private set inputValue(value: string) {
    this.$emit('updateValue', value);
  }
}
